import React, { useContext, useEffect } from "react";
import "../../css/home/home.css"; // Asegúrate de crear este archivo CSS también
import Logo from "../../assets/logos/LogoColurs.png";
import { UtilContext } from "../../context/UtilContext"; // Asegúrate de importar el contexto correcto
import NavbarRegistro from "../../components/navbar/NavbarRegistro";
import { AuthContext } from '../../context/AuthContext';
import { useNavigate, useLocation } from "react-router-dom";

import apple from '../../assets/img/Apple.png'
import play from '../../assets/img/Playstore.png'

const NaturalPersonCompleted = () => {
    const { language } = useContext(UtilContext); // Usa el contexto de Auth
    const { logout } = useContext(AuthContext);
    const { DetailUser } = useContext(AuthContext);
    const navigate = useNavigate();

    /*  useEffect(() => {
         const DetailUser = JSON.parse(localStorage.getItem('userDetails'));
 
         if (DetailUser.document_status === "APPROVED") {
             navigate("/splash", { state: { DetailUser: DetailUser } })
         }
         if (DetailUser.document_status === "INITIAL") {
             navigate("/bienvenido", { state: { DetailUser: DetailUser } })
         }
         if (DetailUser.document_status === "PENDING") {
             navigate("/documentacion-legal", { state: { DetailUser: DetailUser } })
         }
 
     }, []) */
    console.log(DetailUser);

    return (
        <div className="w-full flex flex-col  bg-[#1B1B22] h-[100vh] " >
            <div className=" py-5 px-11 bg-[#1B1B22] ">
                <NavbarRegistro onClose={logout} />
            </div>
            <div className="w-full h-[100vh] flex items-center justify-center " >
                <div className="w-[550px] h-[40vh] flex items-center text-center flex-col justify-center gap-4 " >
                    <img src={Logo} style={{ width: 52, height: 52 }} alt="logo colurs" ></img>
                    <div>
                        <h2 className=" text-2xl mt-8 text-white  " style={{ fontFamily: "brico" }} >¡Bienvenido/a, {DetailUser?.first_name} a Colurs!  </h2>
                        <p className='text-[#B7B7B9]'>Estamos emocionados de tenerte aquí. Descarga nuestra app y descubre una experiencia única para gestionar tus finanzas,
                            realizar transacciones y mucho más, todo desde la palma de tu mano.
                            Empieza hoy mismo y disfruta de nuestros servicios diseñados para facilitar tu vida. </p>
                    </div>

                    <div className="flex justify-center my-4">
                        <a style={{ width: "180.281px", height: "40px", marginRight: "8px" }} href="https://apps.apple.com/co/app/colurs/id6448200343">
                            <img src={apple} width="180.281px" height="70px" alt='img apple' ></img>
                        </a>
                        <a style={{ width: "180.281px", height: "40px" }} href="https://2ly.link/1wqmb">
                            <img src={play} width="180.281px" height="70px" alt="img play" ></img>
                        </a>
                    </div>



                    <p className='text-[#B7B7B9]'>Si tienes dudas o preguntas, no <a href="https://colurs.odoo.com/" target="_blanck" className='text-[#ffffff] underline ' >dudes en contactar a nuestro equipo.</a></p>
                </div>
            </div>
        </div>
    );
};

export default NaturalPersonCompleted;
